import React, { useCallback, useEffect, useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Description, Add } from "@mui/icons-material"
import { Box } from '@mui/material';

import { useToggle } from "hooks/useToggle"
import { useSearch } from "hooks/useSearch"

import { ModalV2 } from "components/Modal/ModalV2"
import CardTable from "components/CardTable/CardTable"
import RegularButton from "components/CustomButtons/Button"
import { TableInputs } from "components/CardTable/TableInputs"

import { PromocodesForm } from './PromocodesForm'
import { columns } from "./columns"

import {
    getPromocodes,
    setPromocodeFilters,
    deletePromocode,
    setSelectedPromocode
} from "redux/actions/promocodes/promocodesActions"

const tableKey = "Promocodes"

export const Promocodes = () => {
    const dispatch = useDispatch()
    const { setSnackbar } = useSearch()
    const [open, handleOpen] = useToggle()
    const { promocodes, station, promocodeSelected, addMode } = useSelector(state => state.promocodes)
    const { isLoadingComp } = useSelector(state => state.search)

    const [openDelete, setOpenDelete] = useState(false);

    useEffect(() => {
        if (!open) dispatch(setSelectedPromocode({ promocode: {}, addMode: true }))
    }, [open])

    const handleSubmit = useCallback((e) => {
        e.preventDefault()
        if (!station?.value && !station?.id) {
            setSnackbar("Debes seleccionar una planta", "danger")
            return
        }
        dispatch(getPromocodes(station))
    }, [station])

    const promocodesMemo = useMemo(
        () =>
            promocodes.map(promocode => {
                return {
                    ...promocode,
                    modal: handleOpen,
                    deleteModal: setOpenDelete
                };
            }),
        [promocodes, handleOpen]
    );

    const handleDelete = useCallback(() => {
        dispatch(deletePromocode(promocodeSelected.id, setOpenDelete))
    }, [promocodeSelected.id])

    return (
        <>
            <CardTable
                data={promocodesMemo}
                columns={columns}
                hasHeader
                blockBtn
                title={"Códigos Promocionales"}
                icon={<Description />}
                isLoading={isLoadingComp?.loadingPromocodes}
                tableContent={
                    <TableInputs
                        reducer="promocodes"
                        stations
                        stationsGridWidth={3}
                        dispatchAction={setPromocodeFilters}
                        submitLoadingKey="loadingPromocodes"
                        submitAction={handleSubmit}
                    />
                }
                tableKey={tableKey}
                hasControl
                controls={
                    <>
                        <RegularButton round justIcon color="info" onClick={handleOpen}>
                            <Add style={{ margin: 0 }} />
                        </RegularButton>
                    </>
                }
            />
            <ModalV2
                open={open}
                onClose={handleOpen}
                title={`${addMode ? 'Generar' : 'Detalle'} código promocional`}
                toRight
            >
                <PromocodesForm onClose={handleOpen} isNew station={station} />
            </ModalV2>
            <ModalV2
                open={openDelete}
                onClose={() => setOpenDelete(false)}
                title="¿Seguro que desea eliminar el cupón?"
                justConfirm
            >
                <Box style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: 8
                }}>
                    <RegularButton color="transparent" fullWidth onClick={() => setOpenDelete(false)}>
                        Cancelar
                    </RegularButton>
                    <RegularButton color="danger" fullWidth onClick={handleDelete}>
                        Confirmar
                    </RegularButton>
                </Box>
            </ModalV2>
        </>
    )
}

